export enum ComparisonTileTexts {
    TITLE = 'Vergleich',
    UNIT_CONSUMPTION = 'kWh',
    LABEL_FRAGMENT_PERCENT = '%',
    LABEL_FRAGMENT_MORE = 'mehr',
    LABEL_FRAGMENT_LESS = 'weniger',
    LABEL_FRAGMENT_THAN_IN = 'als im'
}
